import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/theme";

const CATEGORIES = ["ALL", "Women", "Men", "Kids"];

const CategoryPills = ({ activeCategory, onChange }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 1, md: 2 }, flexWrap: "wrap" }}>
      {CATEGORIES.map((cat) => (
        <Box
          key={cat}
          onClick={() => onChange(cat)}
          sx={{
            px: { xs: 2.5, md: 4 },
            py: { xs: 0.5, md: 1 },
            borderRadius: "100px",
            border: `1px solid #1a1a1a`,
            cursor: "pointer",
            transition: "all 0.3s ease",
            backgroundColor: cat === activeCategory ? "#1a1a1a" : "transparent",
            color: cat === activeCategory ? "#fff" : "#1a1a1a",
            "&:hover": {
              backgroundColor: "#1a1a1a",
              color: "#fff",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            },
            "&:active": {
              transform: "scale(0.96)",
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Poppins-Medium",
              fontSize: { xs: "12px", md: "14px" },
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
          >
            {cat}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CategoryPills;
